import React from 'react';

// Material-UI
import Grid from '@mui/material/Grid';

// Styles
import { useTheme } from '@mui/material/styles';

// Components
import MemberListAction from './MemberListAction';
import MemberListContactInfo from './MemberListContactInfo';
import MemberListHousehold from './MemberListHousehold';

import {
  HouseholdMode
} from '../global';

import {
  Member
} from '../interfaces';

// Responsive hooks
import { useResponsive } from '../hooks/UseResponsive';

interface MemberListProps {
  handleHouseholdOpen: (id: number, view: HouseholdMode) => void;
  householdMemberIDs: Array<number>;
  members: Array<Member>;
}

const MemberList: React.FC<MemberListProps> = (props) => {

  const { isMobile } = useResponsive();

  // #region Styles

  const theme = useTheme();
  const styles = {
    root: {
      borderBottom: '1px solid #e0e0e0',
      padding: theme.spacing(2, 0, 0, 0)
    },
    editIcon: {
      margin: theme.spacing(1, 0, 1, 0)
    },
    statusDisplay: {
      marginTop: theme.spacing(1)
    },
  };

  // #endregion

  // #region Methods

  const renderDesktopList = () => {

    return props.members.map((m: Member) => (
      <Grid container size={12} spacing={1} key={m.memberID} sx={styles.root}>
        <Grid size={3}>
          <MemberListAction handleHouseholdOpen={props.handleHouseholdOpen} householdMemberIDs={props.householdMemberIDs} member={m} />
        </Grid>
        <Grid size={5}>
          <MemberListContactInfo member={m} />
        </Grid>
        <Grid size={4}>
          <MemberListHousehold household={m.household} />
        </Grid>
      </Grid>
    ))

  }

  const renderMobileList = () => {

    return props.members.map((m: Member) => (
      <Grid container size={12} spacing={1} key={m.memberID} sx={styles.root}>
        <Grid size={4}>
          <MemberListAction handleHouseholdOpen={props.handleHouseholdOpen} householdMemberIDs={props.householdMemberIDs} member={m} />
        </Grid>
        <Grid size={8}>
          <MemberListContactInfo member={m} />
          <MemberListHousehold household={m.household} />
        </Grid>
      </Grid>
    ));

  }

  // #endregion

  // Return list in mobile or desktop format
  return (
    <Grid container>
      {isMobile ? renderMobileList() : renderDesktopList()}
    </Grid>
  )
}

export default MemberList;
